import { ApplicationRangeDto } from "app/shared/models/application-range.model";
export class ApplicationRangeVm extends ApplicationRangeDto {
  constructor(init?: Partial<ApplicationRangeVm>) {
    super();
    Object.assign(this, init);
    if (!this.id && this.id !== 0) this.id = null;
    if (!this.from && this.from !== 0 && this.id !== 0) this.from = null;
    if (!this.to && this.to !== 0 && this.id !== 0) this.to = null;
    if (!this.discountAmount && this.id !== 0) this.discountAmount = null;
  }
}
